import { render } from "./RankingItem.vue?vue&type=template&id=53ffaf60&scoped=true"
import script from "./RankingItem.vue?vue&type=script&lang=js"
export * from "./RankingItem.vue?vue&type=script&lang=js"

import "./RankingItem.vue?vue&type=style&index=0&id=53ffaf60&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ffaf60"]])

export default __exports__